import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger, NavigationMenuContent } from "@/components/ui/navigation-menu";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="68371" className="hidden lg:flex gap-10 animate-pulse h-5 w-64 bg-white/5 rounded-none" />;
  }
  return <NavigationMenu viewport={false} className="hidden lg:flex">
      <NavigationMenuList className="gap-10">
        {menuItems.map((item, i) => {
        const isArchitekturProjekte = item.label.replace(/\s+/g, ' ').trim() === "Architektur Projekte";
        const hasChildren = item.children && item.children.length > 0;
        if (isArchitekturProjekte && hasChildren) {
          return <NavigationMenuItem key={item.id} data-index={i}>
                <NavigationMenuTrigger className="bg-transparent hover:bg-transparent text-[14px] font-normal uppercase tracking-wider text-foreground transition-colors hover:text-[#2BA0A3] font-sans h-auto p-0 focus:bg-transparent data-[state=open]:bg-transparent data-[state=open]:text-[#2BA0A3] cursor-pointer gap-1">
                  <span className="mr-1 opacity-70">►</span>
                  {item.label}
                </NavigationMenuTrigger>
                <NavigationMenuContent className="min-w-[240px] bg-background border border-white/5 p-2 duration-300 ease-in-out">
                  <ul className="flex flex-col gap-1">
                    {item.children?.map((child, childIdx) => <li key={child.id} data-index={childIdx}>
                        <NavigationMenuLink asChild>
                          <Link to={child.href || "#"} className="block px-4 py-3 text-[12px] font-normal uppercase tracking-widest text-foreground/90 hover:text-[#2BA0A3] hover:bg-white/5 transition-all duration-200 font-sans">
                            {child.label}
                          </Link>
                        </NavigationMenuLink>
                      </li>)}
                  </ul>
                </NavigationMenuContent>
              </NavigationMenuItem>;
        }
        return <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group relative text-[14px] font-normal uppercase tracking-wider text-foreground transition-colors hover:text-[#2BA0A3] font-sans">
                  <span className="mr-1 opacity-70">►</span>
                  {item.label}
                  <span className="absolute -bottom-1 left-0 h-[1px] w-0 bg-primary transition-all duration-300 group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>;
      })}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-6 p-8 animate-pulse h-64 bg-white/5" />;
  }
  return <nav className="flex flex-col items-center justify-center gap-8">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-2xl font-normal uppercase tracking-widest text-foreground hover:text-[#2BA0A3] transition-colors font-sans" onClick={onClose}>
          {item.label}
        </Link>)}
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="hauptnavigation" className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 border-b border-transparent dark bg-background text-foreground ${isScrolled ? "bg-background/90 backdrop-blur-[10px] border-white/5 shadow-xl" : "bg-background"}`}>
      <div className="container mx-auto px-4 h-20 flex items-center justify-between">
        
        <Link to="/HomePage" className="flex-shrink-0 z-50">
          <img src="https://excited-meerkat.10web.cloud/wp-content/uploads/2026/03/admin-ajax.png" alt="Architektur-News Logo" className="w-auto object-contain !h-[60px]" />
        </Link>

        
        <MenuProvider menu_id="39">
          <DesktopMenuConsumer />
        </MenuProvider>

        
      </div>
    </header>;
}